import {
  useWSModal,
  WSForm,
  WSInputText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { useWSMutation } from "../../../../../query/helpers";
import { useUserId } from "../../../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../../../query/users/queries";
import { entityDataService } from "../../../../../shared/services/entityData";
import { validatorStringTextNumbersSymbols } from "../../../../../shared/validators/validatorStringTextNumbersSymbols";
import { WSServiceError } from "../../../../../utils/serviceHelper";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { newValue: string };

type Props = {
  onClose: () => void;
};

export const FormEditDBA: React.FC<Props> = props => {
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);

  const [mutate, meta] = useWSMutation<void, WSServiceError, FormData>(
    async data => {
      await entityDataService.updateEntity(
        {
          dba: data.newValue
        },
        {
          userId
        }
      );
    },
    {
      onSuccess: props.onClose
    }
  );

  return (
    <WSForm<FormData>
      defaultValues={{
        newValue: queryMember.data?.profile.company?.name
      }}
      onSubmit={mutate}
      validationSchema={Yup.object({
        newValue: validatorStringTextNumbersSymbols
      })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <WSForm.Field
          name="newValue"
          label="Doing business as (DBA) (optional)"
          component={WSInputText}
        />
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditDBA = () =>
  useWSModal(FormEditDBA, {
    title: "Doing business as (DBA)",
    size: "S"
  });
